<!-- reject modal-->
<p-dialog
   header="Reject price"
   [modal]="true"
   [(visible)]="rejectPriceDialogVisible"
   [style]="{ width: '25rem' }">
   <span>Please enter the reject reason.</span>
   <div>
      <textarea
         rows="5"
         pTextarea
         class="form-control"
         [(ngModel)]="rejectComment"></textarea>
   </div>
   <div class="d-flex justify-content-end mt-2">
      <p-button
         label="Cancel"
         severity="secondary"
         class="mr-3"
         (click)="rejectPriceDialogVisible = false" />
      <p-button
         label="Reject"
         [disabled]="!rejectComment"
         (click)="onConfirmReject()" />
   </div>
</p-dialog>
